import React from 'react';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import '../assets/styles/Main.scss';

function Main() {
  function createRipple(event: any) {
    const button = event.currentTarget;
    const ripple = document.createElement('span');

    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = event.clientX - rect.left - size / 2;
    const y = event.clientY - rect.top - size / 2;

    ripple.style.position = 'absolute';
    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;
    ripple.style.background = 'rgba(255, 255, 255, 0.5)';
    ripple.style.borderRadius = '50%';
    ripple.style.transform = 'scale(0)';
    ripple.style.animation = 'rippleEffect 0.6s linear';

    button.appendChild(ripple);

    setTimeout(() => {
      ripple.remove();
    }, 600);
  }
  function handleCVDownload(event: any) {
    createRipple(event);
    const fileName = 'cv.pdf'; // The name to save as

    const a = document.createElement('a');
    a.href = `${process.env.PUBLIC_URL}/cv.pdf`;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  function viewFile(event: any) {
    createRipple(event);
    window.open(`${process.env.PUBLIC_URL}/cv.pdf`, '_blank');
  }
  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img
            src={
              'https://ca.slack-edge.com/T01TWV28A9G-U01TQ6J5538-be56ee7a8c44-512'
            }
            alt="Avatar"
          />
        </div>
        <div className="content">
          <div className="social_icons">
            <a
              href="https://github.com/francis-paul-code"
              target="_blank"
              rel="noreferrer"
            >
              <GitHubIcon />
            </a>
            <a
              href="https://www.linkedin.com/in/francispaulmusango/"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedInIcon />
            </a>
          </div>
          <h1>Francis Musango</h1>
          <p>Software Engineer</p>

          <div className="mobile_social_icons">
            <a
              href="https://github.com/fracis-paul-code"
              target="_blank"
              rel="noreferrer"
            >
              <GitHubIcon />
            </a>
            <a
              href="https://www.linkedin.com/in/francispaulmusango/"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedInIcon />
            </a>
          </div>
          <div style={{ display: 'flex', margin: '5px 0' }}>
            <button
              onClick={handleCVDownload}
              style={{
                position: 'relative',
                overflow: 'hidden',
                background: 'linear-gradient(135deg, #D590E8, #726BF5)',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                margin: '5px 0',
                fontSize: '16px',
                fontWeight: 'bold',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'background 0.3s, transform 0.1s',
                outline: 'none',
              }}
            >
              Download CV
            </button>
            <button
              onClick={viewFile}
              className="view-button"
              style={{
                position: 'relative',
                overflow: 'hidden',
                background: 'transparent',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                margin: '5px 0',
                fontSize: '16px',
                fontWeight: 'bold',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'background 0.3s, transform 0.1s',
                outline: 'none',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <span>View CV</span>
              <span>
                <OpenInNewIcon />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
